import { Injectable } from '@angular/core';
import { Message } from 'primeng/api/message';
import { Subject } from 'rxjs';
import {MessageService} from 'primeng/api';

@Injectable()
export class MessagesService {
    constructor(private messageService: MessageService) {}

    addSuccessMessageChange: Subject<Message> = new Subject<Message>();
    addWarningMessageChange: Subject<Message> = new Subject<Message>();
    addErrorMessageChange: Subject<Message> = new Subject<Message>();
    addInfoMessageChange: Subject<Message> = new Subject<Message>();
    addAllSuccessMessagesChange: Subject<Message[]> = new Subject<Message[]>();
    addAllWarningMessagesChange: Subject<Message[]> = new Subject<Message[]>();
    addAllErrorMessagesChange: Subject<Message[]> = new Subject<Message[]>();
    addAllInfoMessagesChange: Subject<Message[]> = new Subject<Message[]>();

    public addSuccessMessage(message: Message) {
        this.addSuccessMessageChange.next(message);
        this.messageService.add(message)
    }
    public addWarningMessage(message: Message) {
        this.addWarningMessageChange.next(message);
        this.messageService.add(message)
    }
    public addErrorMessage(message: Message) {
        this.addErrorMessageChange.next(message);
        message.sticky = true;
        this.messageService.add(message)
    }
    public addInfoMessage(message: Message) {
        this.addInfoMessageChange.next(message);
        this.messageService.add(message)
    }

    public addAllSuccessMessages(messages: Message[]) {
        this.addAllSuccessMessagesChange.next(messages);
        this.messageService.addAll(messages);
    }
    public addAllWarningMessages(messages: Message[]) {
        this.addAllWarningMessagesChange.next(messages);
        this.messageService.addAll(messages);
    }
    public addAllErrorMessages(messages: Message[]) {
        this.addAllErrorMessagesChange.next(messages);
        this.messageService.addAll(messages);
    }
    public addAllInfoMessages(messages: Message[]) {
        this.addAllInfoMessagesChange.next(messages);
        this.messageService.addAll(messages);
    }
}